import { DateTime } from 'luxon';

import type { MessageContainerFilter } from '@/app/types/Filter';

export const DashboardUtils = {
	createFileName: (filter: MessageContainerFilter) => {
		const startTime = filter.startTime
			? DateTime.fromISO(filter.startTime || '').toFormat('yyyy-MM-dd')
			: '';

		const endTime = filter.endTime
			? DateTime.fromISO(filter.endTime || '').toFormat('yyyy-MM-dd')
			: '';
		const startTimeString = startTime ? `-${startTime}` : '';
		const endTimeString = endTime ? `-${endTime}` : '';
		return `dashboard${startTimeString}${endTimeString}.xlsx`;
	},
};
